export default {
	"Rush.ItsLateOhTheEventIsOver": "来晚了哦，活动已结束",
	"Rush.HotRush": "火热抢购中",
	"Rush.fromTheEnd": "距结束",
	"Rush.OnlyTheBeginningIsLeft": "距开始只剩",
	"Rush.sky": "天",
	"Rush.time": "时",
	"Rush.divide": "分",
	"Rush.second": "秒",
	"Rush.MarketingMarketplaceListingPageProductClick": "营销商城列表页_商品点击",
	"Rush.AListOfStoreItems": "店铺商品列表",
	"Rush.MarketingMarketplace": "营销商城",
	"Rush.SnapItUpNow": "立即抢购",
	"Rush.RobbedOfTheLight": "被抢光啦～"
}